export class PermissionManager {
  private static getFeatures(): string[] {
    try {
      const featuresJson = localStorage.getItem('features');
      return featuresJson ? JSON.parse(featuresJson) : [];
    } catch (error) {
      console.error('PermissionManager > Failed to parse features from localStorage', error);
      return [];
    }
  }

  private static hasFeature(feature: string): boolean {
    const features = this.getFeatures();
    return features.includes(feature);
  }

  private static getRoleId(): number | null {
    const roleId = localStorage.getItem('roleId');
    return roleId ? parseInt(roleId, 10) : null;
  }

  static canAccessPriceManagement(): boolean {
    const roleId = this.getRoleId();
    return roleId === 1 || roleId === 2;
  }

  static canAccessAdminPage(): boolean {
    return this.hasFeature('admin:access');
  }

  static canAccessEstimateForm(): boolean {
    return this.hasFeature('estimator:access');
  }

  static canViewAccounts(): boolean {
    return this.hasFeature('accounts:view');
  }

  static canApproveAccountStatus(): boolean {
    return this.hasFeature('accounts:approve');
  }

  static canModifyAccounts(): boolean {
    return this.hasFeature('accounts:modify');
  }

  static canDeleteAccounts(): boolean {
    return this.hasFeature('accounts:delete');
  }

  static canViewPrices(): boolean {
    return this.hasFeature('prices:view');
  }

  static canModifyPrices(): boolean {
    return this.hasFeature('prices:modify');
  }

  static canCreateEstimates(): boolean {
    return this.hasFeature('estimate:create');
  }

  static getEstimateLoadScope(): string {
    if (this.hasFeature('estimate:view_all')) {
      return 'ALL';
    }
    if (this.hasFeature('estimate:view_own')) {
      return 'OWN';
    }
    return 'NONE';
  }

  static canDownloadJPG(): boolean {
    return this.hasFeature('estimate:export_jpg');
  }

  static canSendSMS(): boolean {
    return this.hasFeature('messaging:sms');
  }

  static canSendKakao(): boolean {
    return this.hasFeature('messaging:kakao');
  }

  static canAccessBoard(): boolean {
    return this.hasFeature('board:access');
  }

  static canCreateBoardPost(): boolean {
    return this.hasFeature('board:create');
  }

  static canModifyAllBoardPosts(): boolean {
    return this.hasFeature('board:modify_all');
  }

  static canSetNotice(): boolean {
    return this.hasFeature('board:set_notice');
  }

  static canPrint(): boolean {
    return true;
  }
}
